<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'shipto_objectives.import'}"><i class="fa fa-plus"></i> Importar</router-link>
      <router-link class="btn btn-primary" :to="{name:'shipto_objectives.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="shiptoObjectivesGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'shiptoObjectivesGrid',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      preload: [],
      url: 'stars/shipto_objectives',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'ym',
        title: 'Ano/Mês',
        width: '120px'
      },
      {
        field: 'stars_st_code',
        title: 'ST',
        width: '120px'
      },
      {
        field: 'stars_cha_code',
        title: 'CHA',
        width: '120px'
      },
      {
        field: 'ship_to',
        title: 'Ship To',
        width: '120px'
      },
      {
        field: 'ufs_niv',
        title: 'NIV UFS',
        width: '120px'
      },
      {
        field: 'spreads_niv',
        title: 'NIV Spreads',
        width: '120px'
      },
      {
        field: 'ufs_to_top10',
        title: 'UFS TO Top10',
        width: '120px'
      },
      {
        field: 'ufs_to_total',
        title: 'UFS TO Total',
        width: '120px'
      },
      {
        field: 'spreads_to_top10',
        title: 'Spreads TO Top10',
        width: '120px'
      },
      {
        field: 'spreads_to_total',
        title: 'Spreads TO Total',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'shipto_objectives.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('shipto_objectives.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
